/**
 * The properties a deal's Product node can carry, and inside `offers` the properties its Offer can
 * carry. Two things depend on these lists staying complete:
 *
 * - `getDealStructuredData` returns `DealProductNode`, so a new property on the node literal that
 *   is not in the list fails to compile (excess property check). Spread-in properties such as the
 *   gtin ones are not checked that way, so keep them listed by hand.
 * - `buildPageStructuredData` fills only these properties when it merges two copies of one deal, so
 *   a copy from another endpoint can complete a node but never add anything else.
 */
export const DEAL_PRODUCT_PROPERTIES = [
  "name",
  "description",
  "image",
  "gtin8",
  "gtin12",
  "gtin13",
  "gtin14",
  "sku",
  "brand",
  "category"
] as const;

export const DEAL_OFFER_PROPERTIES = [
  "url",
  "price",
  "priceCurrency",
  "availability",
  "itemCondition",
  "seller"
] as const;

export type DealProductProperty = typeof DEAL_PRODUCT_PROPERTIES[number];
export type DealOfferProperty = typeof DEAL_OFFER_PROPERTIES[number];

export type DealOfferNode = { "@type": "Offer"; "@id": string } & { [K in DealOfferProperty]?: unknown };

export type DealProductNode = { "@type": "Product"; "@id": string; offers: DealOfferNode } & {
  [K in DealProductProperty]?: unknown;
};
